import React, { useState, useEffect } from "react";
import { Tabs } from "antd";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import HelpComponent from "./help/index.jsx";
import PartnerList from "./partners.jsx";
import Feedback from "./feedback/index.jsx";
import Restore from "./Restore.jsx";

export default function SuperAdmin() {
  const [activeKey, setActiveKey] = useState();
  const navigate = useNavigate();

  useEffect(() => {
    let tabVal = sessionStorage.getItem("activeKey");
    if (tabVal) {
      setActiveKey(tabVal);
    }
  }, []);

  const changeTab = (activeKey) => {
    setActiveKey(activeKey);
    sessionStorage.setItem("activeKey", activeKey);
  };

  // window.onbeforeunload = function () {
  //   sessionStorage.clear();
  // };

  const [reload, setreload] = useState(false);

  function reloadFunc() {
    setreload(!reload);
  }

  return (
    <>
      <div className="tabContainer">
        <Tabs defaultActiveKey="1" activeKey={activeKey} onChange={changeTab}>
          <Tabs.TabPane tab="Home" key={"1"}>
            <PartnerList reload={reload} reloadFunc={reloadFunc} />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Help" key={"2"}>
            <HelpComponent />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Support & Feedback" key={"3"}>
            <Feedback />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Restore Partners" key={"4"}>
            <Restore reload={reload} reloadFunc={reloadFunc} />
          </Tabs.TabPane>
        </Tabs>
      </div>

      <div className="footerlogo">
        <div
          className="footer-content"
          onClick={() => window.open("https://www.connectsu.co.uk/", "_blank")}
          style={{ cursor: "pointer" }}
        >
          {/* <span>Powered by </span> */}
          <div className="footer-logo">
            <img
              src={require("../../assets/images/PoweredNew.png")}
              alt="connectsU logo"
            />
          </div>
        </div>
      </div>
    </>
  );
}
